import React from 'react';
import * as PropTypes from 'prop-types';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const sharedStyle = {
  backgroundColor: '#feebe8', // Light tint of #f1543b
  borderColor: '#fdc5bd',     // Medium tint 
  color: '#f1543b',           // Main color
  boxShadow: 'none',
};

const RemoveButtonGroup = ({ onRemoveClick, children, ...props }) => (
  <Button.Group
    style={{
      marginRight: 8,
      marginBottom: 8,
    }}
    {...props}
  >
    {React.cloneElement(children, {
      style: { ...sharedStyle, ...children.props.style },
    })}
    <Button
      onClick={onRemoveClick}
      style={{ ...sharedStyle, padding: '0 8px' }}
      icon={<CloseOutlined />}
    />
  </Button.Group>
);

RemoveButtonGroup.propTypes = {
  onRemoveClick: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default RemoveButtonGroup;
